import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Plus, Minus, X, MessageCircle } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "../ui/popover";
import { useHeliosChat } from "../../hooks/useHeliosChat";
import { usePageUpdateGuard } from "../../hooks/usePageUpdateGuard";
import { ChatMessages } from "./ChatMessages";
import { ChatComposer } from "./ChatComposer";
import "../../helios-chat.css";

export const FloatingHeliosChat = ({ hidden = false, onOpenChange }) => {
  const [open, setOpen] = useState(false);
  useEffect(() => { onOpenChange?.(open); }, [open, onOpenChange]);
  const { pathname } = useLocation();
  const chat = useHeliosChat(open, pathname);
  usePageUpdateGuard(open || chat.busy || chat.restoring || chat.restoreFailed || chat.canRetry || Boolean(chat.draft.trim()));
  useEffect(() => { if (hidden) setOpen(false); }, [hidden]);
  if (hidden) return null;
  return <Popover open={open} onOpenChange={setOpen}>
    <PopoverTrigger asChild><button type="button" className="helios-chat-launcher" data-testid="chat-launcher" aria-label={open ? "Close Helios conversation" : "Open Helios conversation"} title="Talk to Helios">
      {open ? <X size={23} /> : <><img src="/helios-mark.png" alt="" aria-hidden="true" /><span>Talk to Helios</span><MessageCircle size={18} /></>}
    </button></PopoverTrigger>
    <PopoverContent align="end" side="top" sideOffset={12} collisionPadding={12} className="helios-chat-panel" data-testid="chat-panel" data-phase={chat.phase} aria-busy={chat.busy || chat.restoring} aria-labelledby="helios-chat-title" onOpenAutoFocus={event => { if (window.matchMedia("(max-width: 767px)").matches) event.preventDefault(); }}>
      <header className="helios-chat-header">
        <div><img src="/helios_logo_light.png" alt="Helios Brain" data-testid="chat-header-logo" /><h2 id="helios-chat-title" data-testid="chat-title">Your world model partner</h2></div>
        <button type="button" title="New conversation" aria-label="New conversation" data-testid="chat-new-conversation" disabled={chat.phase === "resetting" || chat.restoring} onClick={chat.reset}><Plus size={19} /></button>
        <button type="button" title="Minimize chat" aria-label="Minimize chat" data-testid="chat-close" onClick={() => setOpen(false)}><Minus size={19} /></button>
      </header>
      <ChatMessages chat={chat} />
      <ChatComposer chat={chat} />
    </PopoverContent>
  </Popover>;
};